// utils/authChannel.ts
let _BCC: BroadcastChannel | null = null

export function getAuthChannel(): BroadcastChannel {
    if (!_BCC) _BCC = new BroadcastChannel("authChannel")
    return _BCC
}

export function notifyAuthChanged(token: string | null, userData: any, systemConfig: any , deviceId:any) {
    const bc = getAuthChannel();
    bc.postMessage({ type: "AUTH_CHANGED", payload: { token, userData, systemConfig, deviceId } })
}

export function notifyAuthLogout(logoutVerify:boolean=false) {
    const bc = getAuthChannel()
    bc.postMessage({ type: "LOGOUT_CHANGED", logoutVerify})
}

/** Notify other tabs that this tab detected session expired (e.g. 401/403). Other tabs should clear and redirect. */
export function notifySessionExpired(message?: string) {
    const bc = getAuthChannel()
    bc.postMessage({ type: "SESSION_EXPIRED", payload: { message } })
}
